/**
 * Checked-in runtime data for the Create/Edit Transaction modal (PVAL-26341).
 *
 * **Both fixtures this file used to carry are gone, and nothing should replace them in kind.**
 *
 * It held a Prometheus comparison sample column and a set of create-mode seeds — fabricated values
 * (`Entry_Memo: 'Sample comparison value'`, `notes: 'New draft seeded for the demo'`, a round
 * 1000 @ 100 trade) that rendered in the dialog looking exactly like a record's own data. That was
 * tolerable while the dialog had no real source. It stopped being tolerable when the Edit dialog
 * began reading whole trades from `trades/get` (PVAL-26492): a fabricated value beside a real one,
 * in a column the status dots then score `match`/`diff` against, is a wrong answer rather than a
 * placeholder.
 *
 * The comparison side will be filled by its own endpoint. Create defaults, when they are wanted,
 * belong in the metadata document beside the field they default — which is where the old comment on
 * them already said they belonged.
 *
 * Value LISTS used to live here too, keyed by an id the metadata document never carried on any
 * field; PVAL-26493 deleted that map and the dialog now reads each field's options off the
 * document's own `listValues` block instead. Do not reintroduce a list here: a field's allowed
 * values belong beside the field, in the metadata the CRUD API serves.
 *
 * This lives beside `enfusion-api-catalog.fixture.ts` rather than under `src/mocks` on purpose:
 * `src/mocks` is test-only (its files are `*.mock.spec.ts` and never ship).
 */

/**
 * Values a brand-new transaction opens with, per tran category.
 *
 * Empty, deliberately. A create draft now opens blank and its required fields are the user's to
 * answer, which is what makes the Save gate mean something — the seeds that used to be here existed
 * to open the draft savable without typing, which is a demo property, not a product one.
 *
 * Kept as a constant rather than deleted outright so the seam keeps its shape: when defaults arrive
 * they arrive from the document, and `StaticTransactionValueService.createDefaults` is where they
 * will be read.
 */
export const TRANSACTION_CREATE_DEFAULTS: Readonly<
  Record<string, Readonly<Record<string, unknown>>>
> = {}
